<template>
  <div>
    <v-app-bar
      app
      color="#121621"
      light
    >
      
      
      <v-img
        alt="Vuetify Logo"
        class="shrink mr-2"
        contain
        src="../assets/images/logo.png"
        transition="scale-transition"
        width="32"
        height="32"
        @click="goHome"
      />
      <v-spacer><span style="font-weight:bold;color: #F4F4F4;">ConfluxDapp</span></v-spacer>
      <v-app-bar-nav-icon  @click="showMore()"></v-app-bar-nav-icon>

      <template v-slot:extension>
        <v-row no-gutters style="justify-content: space-between;align-items: center;">
          <v-col sm="6" md="6" cols="6">
          
            
          </v-col>
          <v-col sm="6" md="6" cols="6">
            <v-btn
            color="#222222"
            class="login-btn"
            text
            rounded
            elevation="0"
            style="margin:8px 0px;"
            @click="login()"
          >
          <v-img
            alt="Vuetify Logo"
            class="shrink mr-2"
            contain
            src="../assets/images/circle.svg"
            transition="scale-transition"
            width="8"
            v-show="isLogin"
          />
            
            <span class="login-text" style="color: #F4F4F4;">{{isLogin ? accountStr: $t('home.connect')}}</span>
          </v-btn>
          </v-col>
        </v-row>
          
        
          
        
      </template>

    </v-app-bar>
    <v-navigation-drawer v-model="drawer"
      fixed
      temporary>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            ConfluxDapp
          </v-list-item-title>
          <v-list-item-subtitle>
            
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          @click.stop="gotoPage(item.path)"
        >
          <!-- <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon> -->

          <v-list-item-content >
            <v-list-item-title  class="menu-title">{{ $t(item.title) }}</v-list-item-title>
            <v-list-item v-for="subItem in item.subItems"
            :key="subItem.title"
            >
              <v-list-item-content>
                <v-list-item-title @click.stop="gotoPage(item.path, subItem.type)" :class="subItem.active?'sub-menu-active sub-menu-title':'sub-menu-title'" >{{ $t(subItem.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="item in items2"
          :key="item.title"
          link
        >
          <!-- <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon> -->

          <v-list-item-content>
            <v-list-item-title class="menu-title">{{ $t(item.title) }}</v-list-item-title>
            <v-list-item v-for="subItem in item.subItems"
            :key="subItem.title"
            >
              <v-list-item-content>
                <v-list-item-title  @click.stop="callfun(subItem.funName, $event)" :class="subItem.active?'sub-menu-active sub-menu-title':'sub-menu-title'" >{{ $t(subItem.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
  
    
</template>

<script>
export default {
  name: 'AppHeader',

  data: () => ({
    cfx_account: "",
    searchValue: '',
    isLogin: false,
    drawer: false,
    sheet: false,
    group: null,
    items: [],
    items2: [
      { title: 'menu.language', icon: 'mdi-help-box', subItems:[{title: 'menu.language_en', active: true, funName: 'changeLanguage'},{title: 'menu.language_zh', active: false, funName: 'changeLanguage'}] },
    ],
    right: null
  }),
  beforeCreate: function() {

  },
  mounted: function() {
    let that = this

    this.$i18n.locale = localStorage.getItem('language')
    
    if(this.$i18n.locale == 'en') {
      this.items2[0].subItems[0].active = true
      this.items2[0].subItems[1].active = false
    } else {
      this.items2[0].subItems[1].active = true
      this.items2[0].subItems[0].active = false
    }

    window.conflux.on('accountsChanged', function(accounts) {
      that.accountStr = null
      that.isLogin = false
      that.globalVar.account = null
      localStorage.clear()
    })
    
  },
  methods: {
    login: async function(way) {
      if("espace" == way) {
        this.cfx_account = await this.connectMetamask();
      } else {
        this.cfx_account = await this.connectPortal();
      }

      if(this.cfx_account) {
          this.isLogin = true;
          this.globalVar.account = this.cfx_account
          
          this.accountStr = null
          this.accountStr = this.cfx_account.substring(0,4) + "..." + this.cfx_account.substring(this.cfx_account.length-4);
        }

        return this.cfx_account
      
      
      
    },
    getSearchValue: function() {
      return this.searchValue
    },
    searchNFT: function() {
      
      let routeUrl = this.$router.resolve({ path: '/explore', query: {searchValue: this.searchValue}})
      window.open(routeUrl.href, '_self');
    },
    showMore: function() {
      this.drawer = true;
    },
    hideMore: function() {
      this.drawer = false
    },
    gotoPage: function(pagePath, type) {
      this.$router.push({ name: pagePath, params: {type: type}})
    },
    callfun: function(funName, param) {
      
      this.$options.methods[funName](this, param);
    },
    changeLanguage: function(that) {
      if (that.$i18n.locale == 'en') {
        that.$i18n.locale = 'zh-cn'
        that.items2[0]['subItems'][0].active = false
        that.items2[0]['subItems'][1].active = true
      } else {
        that.$i18n.locale = 'en'
        that.items2[0]['subItems'][0].active = true
        that.items2[0]['subItems'][1].active = false
      }

      localStorage.setItem('language', that.$i18n.locale)

      that.hideMore()

    },
    goHome: function() {
      this.$router.push({path: '/'})
    },
    showSearchValue: function(value) {
      this.searchValue = value
      //清空原本的查询条件
      if(value) {
        localStorage.removeItem("selectedCategory")
      }
      
    }
  }

};
</script>

<style scoped>
  .tuoyuan {
    position: absolute;
    width: 8px;
    height: 8px;
    background: #7CD77B;
  }

  .main-body {
    background-color: #F4F4F4;
  }

  .head-btn {
    margin: 0px 16px;
    min-width: 100pt!important;
    height: 28px!important;
  }

  .head-img {
    margin: 0px 16px;
  }

  .card-box {
    padding-left: 16px;
  }

  .card-name {
    height: 32pt;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.016) 0%, rgba(0, 0, 0, 0.6) 75.43%, rgba(0, 0, 0, 0.72) 100%);
    backdrop-filter: blur(10px);
    display: block;
    position: absolute;
    bottom: 0px;
    color: white;
    line-height: 25pt;
    width: 100%;
    font-size: 9pt;
    padding-left:10px;
  }

  .card-auction {
      height: 37pt;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.016) 0%, rgba(0, 0, 0, 0.6) 75.43%, rgba(0, 0, 0, 0.72) 100%);
      backdrop-filter: blur(10px);
      display: block;
      position: absolute;
      bottom: 0px;
      color: white;
      line-height: 32pt;
      width: 100%;
      font-size: 9pt;
      padding-left:10px;
  }

  .nft-subname {
    height: 12pt;
    line-height: 16pt;
    width: 100%;
    display: block;
  }

  .nft-price {
    height: 12pt;
    line-height: 16pt;
    width: 100%;
    display: block;
    color: #3DDCFF;

  }

  .auction-clock {
    height: 12pt;
    width: 12pt;
  }

  .auction-times {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 12pt;
    line-height: 12pt;
    font-family: Fira Sans;
    font-style: normal;
    font-size: 9pt;
    text-transform: uppercase;
  }

  .news-mark {
    font-family: Fira Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #222222;
    opacity: 0.7;
  }

  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #121621;
  }
  .v-btn__content {
    color: #F4F4F4!important;
  }
</style>
